export default "__VITE_ASSET__DyzhLl85__"